import React, { useEffect, useState } from 'react';
import { useAppActions, useAppState } from '../../../overmind';
import { PermissionsEntityDropdownWidget } from '../../../widgets/analytics/permissions-entity-dropdown/permissions-entity-dropdown.widget';
import { PagePath } from '../../../navigation/navigation.enums';
import { PermissionsEntity } from '../../../widgets/analytics/permissions-entity-dropdown/permissions-entity-dropdown.models';
import { Entity } from '../../../models';
import { ActionCard, PageHeader } from '@keplerco/core';
import { SkillsBreakdownWidget, DailyLoginsWidget, LeaderboardWidget } from '../../../widgets';
import { CourseEngagementWidget } from '../../../widgets/analytics/overview/course-engagement.widget';
import { EntityAverageWidget } from '../../../components/general/average/entity-average/entity-average.widget';
import { HeatmapWidget } from '../../../widgets/analytics/heatmap/heatmap.widget';
import RankedEntitiesWidget from '../ranked-entities/ranked-entities.widget';
import { Daterange } from '../../../components/inputs/daterange/daterange.component';
import analyticsStyles from '../analytics.module.css';
import classNames from 'classnames';
import { useKeplerNavigate } from '../../../navigation/guards/use-kepler-navigate';
import { OrganizationLevelType } from '../../../enums';

export function AnalyticsOverviewPage(): JSX.Element {
  const keplerNavigate = useKeplerNavigate();

  const actions = useAppActions();
  const { dateRangeOutput, companyVariables, permissions, user } = useAppState();

  //TODO: Relook how we are defining entity
  const [entity, setEntity] = useState<PermissionsEntity>();
  const [activeAssessmentList, setActiveSkillAssessmentList] = useState<Entity[]>();

  useEffect(() => {
    async function getData() {
      if (!!user?.isSystemAdmin ||
        permissions?.analytics?.organizationLevels?.some(perm => perm.organizationLevel === OrganizationLevelType.Company)) {
        const tempActiveAssessmentList = await actions.getActiveAssessments();
        setActiveSkillAssessmentList(tempActiveAssessmentList);
      }
    }

    getData();
  }, [companyVariables.slug]);

  return (
    <div className={classNames('pageWrapper wrapper', analyticsStyles.page)}>
      <PageHeader
        breadcrumbs={[
          { name: 'Analytics', url: PagePath.analyticsBase },
          { name: 'Overview', url: window.location.pathname },
        ]}
        title="Overview"
        type="actions"
        divider
      >
        <div className="headerActions" style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap' }}>
          <PermissionsEntityDropdownWidget entity={entity} onClick={setEntity} />

          <Daterange
            defaultValue={dateRangeOutput}
            onDaterangeChange={result => {
              actions.setGlobalDateRange(result);
            }}
          />
        </div>
      </PageHeader>

      {!!activeAssessmentList?.length && (
        <ActionCard
          icon="/assessments-pending.svg"
          title="Assessments in progress"
          description="Your team has outstanding assessments"
          action={{
            type: `anchor`,
            text: `View Assessments`,
            onClick: () => keplerNavigate(`${PagePath.analyticsBase}${PagePath.analyticsAssessments.replace(':companySlug', companyVariables.slug!)}`),
          }}
        />
      )}
      <div className={analyticsStyles.oneTwoGrid}>
        <EntityAverageWidget entity={entity} path={PagePath.analyticsOverview} />

        <SkillsBreakdownWidget description="A list of the skills in the company and the corresponding skill scores" entity={entity} path={PagePath.analyticsOverview} />
      </div>
      <HeatmapWidget entity={entity} />
      <RankedEntitiesWidget rankingLabel="users" organizationLevelType={OrganizationLevelType.Learner} entitySlugs={!!entity?.entity.slug ? [entity.entity.slug] : []} />
      <CourseEngagementWidget entity={entity} isLearner={false} />
      <DailyLoginsWidget entity={entity} />
      <div className={analyticsStyles.twoOneGrid}>
        <LeaderboardWidget entity={entity} />
      </div>
    </div>
  );
}
